<p-confirmDialog rejectButtonStyleClass="p-button-outlined"></p-confirmDialog>
<app-hard-copy-activity [documentNumber]="documentNumber"
    [isCreateHardCopyActivitySliderOpen]="isHardCopyActivitySliderOpen" [documentVersion]="documentVersion" [activityId]="dataActivityId" 
    [(showRemovedCopies)]="showRemovedCopiesChange"
    [documentStatus]="documentStatus" (closeHardCopyActivitySlider)="closeSliderOnConfiramtion($event)">
</app-hard-copy-activity>

<div *ngIf="displayConfirmationDialog">
    <app-my-hard-copy-confirmation
      [hardcopyActivityId]="completeHardcopyActivityId"
      [removedCopiesMax]="maxDefaultCopies"
      [removeActivity]="isRemoveActivity"
      [closeConfirmationModalVisible]="isConfirmationModalVisible"
      (closeConfirmationModal)="handleConfirmation($event)"
    >
    </app-my-hard-copy-confirmation>
  </div>
<app-top-bar [topBarTitle]="topBarTitle"></app-top-bar>
<div class="bpt-main-content-container" *ngIf="isScreenAccessible else screenNotAccessible">
  <div class="flex flex-column card-container">
    <app-panel-list *ngIf="!showLoader" [panelList]="myHardCopydata"
    [noResultFound] = "!ispanelListDataAvailable">
      <ng-template #templateRef let-data="dataVar">
        <div panel-content>
          <div class="grid">
            <div class="col1">
              <div class="fields-row">
                <div class="col4 column1-width">
                  <app-label labelText="{{ 'Document Version' }}"></app-label>
                  <div class="overflow-ellipsis underline title font-semibold">
                  <b pTooltip= "{{data.documentNumber}} {{data.documentTitle}} (v{{data.documentVersion}})">
                    <a style="cursor: pointer;" (click)="openDocument(data?.documentNumber,data?.documentVersion)">{{ data?.documentNumber }} {{(data?.documentTitle.length>10)? 
                    (data?.documentTitle | slice:0:10)+'..':(data?.documentTitle)}} (v{{ data?.documentVersion }})</a></b></div>
                </div>
                <div class="col4 overflow-ellipsis column2-width">
                  <app-label labelText="{{ 'Assigned User' }}"></app-label>
                  <div class="text-container overflow-ellipsis">
                    <app-read-only [ngClass]="{'inActiveGroup':data?.assignedUser.isActive===false || data?.assignedUser.isTerminated==true}"
                      readonlyText="{{ data?.assignedUser.assignedUserName }}"
                      toolTipMessage="{{ data?.assignedUser.assignedUserName }}"
                    ></app-read-only>
                  </div>
                </div>
                <div class="col4 notesCol overflow-ellipsis column3-width">
                  <app-label labelText="{{ 'eQMS Scope' }}"></app-label>
                  <div class="text-container overflow-ellipsis">
                    <app-read-only
                      readonlyText="{{ data?.eQMSScopeDisplayName }}"
                      toolTipMessage="{{ data?.eQMSScopeDisplayName }}"
                    ></app-read-only>
                  </div>
                </div>
              </div>
              <div class="fields-row">
                <div class="col4 column1-width">
                  <div class="activity-status-col">
                    <app-label class="activity-col" labelText="{{ 'Activity' }}"></app-label>
                    <app-label labelText="{{ 'Status' }}"></app-label>
                  </div>
                  <div class="activity-status-col">
                    <app-read-only class="activity-col"
                      readonlyText="{{ data?.activity }}"
                    ></app-read-only>
                    <div class="grid pt-1">
                      <div class="col max-w-0 ml-1">
                        <em
                          class="pi pi-circle-fill pt-1"
                          [ngClass]="{
                            scheduled: data?.status == 'Scheduled',
                            pending: data?.status == 'Pending',
                            done: data?.status == 'Done'
                          }"
                        ></em>
                      </div>
                      <div class="col max-w-6rem ml-2">
                        <app-read-only
                          readonlyText="{{ data?.status }}"
                        ></app-read-only>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col4 column2-width wrap-copies">
                  <div class="col5 col-copies">
                    <app-label labelText="{{ 'Copies' }}"></app-label>
                    <app-read-only
                      readonlyText="{{ data?.copies }}"
                    ></app-read-only>
                  </div>
                  <div
                    class="col5 col-removed-copies"
                    *ngIf="data?.activity == 'Remove' && data?.status == 'Done'"
                  >
                    <app-label labelText="{{ 'Removed Copies' }}"></app-label>
                    <app-read-only
                      readonlyText="{{ data?.removedCopies }}"
                    ></app-read-only>
                  </div>
                </div>
                <div class="col4 column3-width">
                  <app-label
                    labelText="{{ 'Hardcopy Storage Location' }}"
                  ></app-label>
                  <app-read-only
                    readonlyText="{{ data?.hardcopyStorageLocation }}"
                  ></app-read-only>
                </div>
              </div>
            </div>
            <div class="col6"></div>
            <div class="col2">
              <app-label labelText="{{ 'Notes' }}"></app-label>
              <app-read-only readonlyText="{{ data?.notes }}"></app-read-only>
            </div>
            <div class="col7 speedDialAlign">
              <div class="col2">
                <app-speed-dial [menuItemsData]="setData(data)"> </app-speed-dial>
              </div>
            </div>
          </div>

        </div>
      </ng-template>
    </app-panel-list>
  </div>
</div>
<app-hardcopyactivity-audit-modal *ngIf="showHardCopyActivityModal"
[hardCopyActivityId]="hardCopyActivityIdForAudit"
[isHardCopyActivityAuditModalShow]="showHardCopyActivityModal"
(showHardCopyActivityAuditModal)="closeHardCopyActivityAuditModal($event)">
</app-hardcopyactivity-audit-modal>
<ng-template #screenNotAccessible>
  <app-error [errorMessage]="errorMessage"></app-error>
</ng-template>
